<script>
  import ChartSelector from "./components/ChartSelector.svelte";
  import SingleSelect from "./components/SingleSelect.svelte";
  import NumberSlider from "./components/NumberSlider.svelte";
  import MultiSelect from "./components/MultiSelect.svelte";
  import TextInput from "./components/TextInput.svelte";
  import NumberInput from "./components/NumberInput.svelte";
  import ColorPicker from "./components/ColorPicker.svelte";
  import Checkbox from "./components/Checkbox.svelte";

  export let variableOptions;
  export let xVariable;
  export let yVariable;
  export let activeYear;
  export let mostRecent;
  export let activeChartType;
  export let xAxisTitle;
  export let xMin;
  export let xMax;
  export let xLog;
  export let yAxisTitle;
  export let yMin;
  export let yMax;
  export let yLog;
  export let dotRadius;
  export let dotOpacity;
  export let dotColor;
  export let chartTitle;
  export let xReference;
  export let yReference;
  export let groupsOptions;
  export let activeGroup;
  export let highlightGroup;
  export let primaryCountry;
  export let scatterData;
  export let lineData;
  export let referenceCountries;
  export let showDots;
  export let benchmarkValue;
  export let showOutlines;
  export let reversePalette;
  export let paletteMin;
  export let paletteMax;
  export let legendLabel;
  export let paletteValue;
  export let regressionLine;

  const paletteOptions = [
    { value: "interpolateBlues", label: "Blues",},
    { value: "interpolateGreens", label: "Greens" },
    { value: "interpolateGreys", label: "Greys" },
    { value: "interpolateOranges", label: "Oranges" },
    { value: "interpolatePurples", label: "Purples" },
    { value: "interpolateReds", label: "Reds" },
    { value: "interpolateOrRd", label: "Orange-Red" },
    { value: "interpolateYlGn", label: "Yellow-Green" },
    { value: "interpolateYlOrRd", label: "Yellow-Orange-Red" },
    { value: "interpolateBuPu", label: "Blue-Purple" },
  ];

  const groupBy = (item) => item.group;

</script>

  <div class="ui">
  <div class="ui-section">
    <div class="ui-section-header">Chart type</div>
    <ChartSelector bind:activeChartType />
  </div>
  <div class="ui-section grey">
    <div class="ui-section-header">Data</div>

    {#if activeChartType === "scatter"}
      <SingleSelect
        label="X"
        options={variableOptions}
        bind:value={xVariable}
        clearable={false}
        wideList={true}
        searchable={true}
      />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "map" || activeChartType === "bar"}
      <SingleSelect
        label={activeChartType === "map" || activeChartType === "bar" ? "Variable" : "Y"}
        options={variableOptions}
        bind:value={yVariable}
        clearable={false}
        wideList={true}
        searchable={true}
      />
    {/if}

    {#if activeChartType === "benchmark"}
      <MultiSelect
        label="Variables"
        options={variableOptions}
        bind:value={benchmarkValue}
      />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "benchmark" || activeChartType === "map" || activeChartType === "bar"}
      <NumberSlider
        label={"Year"}
        bind:numberValue={activeYear}
        min={1960}
        max={2027}
        step={1}
        disabled={mostRecent}
      />
      <Checkbox
        label={"Show most recent year available"}
        bind:checked={mostRecent}
      />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "benchmark" || activeChartType === "map"}
    <SingleSelect
      label="Display group"
      options={groupsOptions}
      bind:value={activeGroup}
      {groupBy}
      clearable={true}
      wideList={false}
      searchable={false}
    />
    {/if}
  </div>
  <div class="ui-section">
    <div class="ui-section-header">Axes</div>

    {#if activeChartType === "scatter" || activeChartType === "line"}
      <div class="ui-section-subheader">X Axis</div>
      <TextInput label="Title" bind:text={xAxisTitle}/>
      <NumberInput label="Minimum value" bind:number={xMin} />
      <NumberInput label="Maximum value" bind:number={xMax} />
      {#if activeChartType === "scatter"}
        <Checkbox label={"Logarithmic scale"} bind:checked={xLog} />
      {/if}
      <div class="ui-section-subheader">Y Axis</div>
      <TextInput label="Title" bind:text={yAxisTitle} />
      <NumberInput label="Minimum value" bind:number={yMin} />
      <NumberInput label="Maximum value" bind:number={yMax} />
      {#if activeChartType === "scatter"}
        <Checkbox label={"Logarithmic scale"} bind:checked={yLog} />
      {/if}
    {/if}

    {#if activeChartType === "benchmark"}
      <div class="ui-section-subheader">Axis labels</div>
      {#if benchmarkValue !== null}
      {#each benchmarkValue as benchmarkVariable, index}
        <TextInput
          label={`Axis label ${index + 1}`}
          bind:text={benchmarkVariable.label}
        />
      {/each}
      {/if}
    {/if}
  </div>
  <div class="ui-section grey">
    <div class="ui-section-header">Annotate</div>
    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "benchmark" || activeChartType === "bar" || activeChartType === "map"}
    <TextInput label="Chart title" bind:text={chartTitle} />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "benchmark" || activeChartType === "bar" || activeChartType === "map" || activeChartType === "countryprofile"}
    <SingleSelect
      label="Primary country"
      options={activeChartType === "scatter" ? scatterData : lineData}
      bind:value={primaryCountry}
      clearable={true}
      wideList={false}
      searchable={true}
    />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "benchmark" || activeChartType === "bar"}
      <MultiSelect
        label="Reference countries"
        options={activeChartType === "scatter" ||
        activeChartType === "benchmark"
          ? scatterData
          : lineData}
        bind:value={referenceCountries}
      />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "benchmark"}
      <SingleSelect
        label="Highlight group"
        options={groupsOptions}
        bind:value={highlightGroup}
        {groupBy}
        clearable={false}
        wideList={false}
        sarchable={true}
      />
    {/if}

    {#if activeChartType === "scatter" || activeChartType === "line"}
      <NumberInput label="X reference line" bind:number={xReference} />
      <NumberInput label="Y reference line" bind:number={yReference} />
    {/if}

    {#if activeChartType === "scatter"}
      <Checkbox label={"Linear regression line"} bind:checked={regressionLine}></Checkbox>
    {/if}
  </div>
  <div class="ui-section">
    <div class="ui-section-header">Style</div>
    {#if activeChartType === "scatter" || activeChartType === "line" || activeChartType === "benchmark"}
      <NumberSlider
        label={"Dot radius"}
        min={0}
        max={50}
        bind:numberValue={dotRadius}
        step={1}
      />
      <NumberSlider
        label={"Dot opacity"}
        min={0}
        max={1}
        bind:numberValue={dotOpacity}
        step={0.1}
      />
    {/if}
    {#if activeChartType === "scatter" || activeChartType === "benchmark"}
      <ColorPicker
        label={"Dot color"}
        startColor={dotColor}
        bind:pickedColor={dotColor}
      />
    {/if}
    {#if activeChartType === "line" && ((referenceCountries && referenceCountries.length > 0) || primaryCountry)}
      <Checkbox label={"Show data points"} bind:checked={showDots}/>
    {/if}
    {#if activeChartType === "map"}
      <SingleSelect
        label={"Color palette"}
        options={paletteOptions}
        bind:value={paletteValue}
        clearable={false}
        wideList={false}
        searchable={false}
      />
      <Checkbox label={"Reverse color palette"} bind:checked={reversePalette} />
      <TextInput label="Legend label" bind:text={legendLabel} />
      <NumberInput label="Minimum value" bind:number={paletteMin} />
      <NumberInput label="Maximum value" bind:number={paletteMax} />
      <Checkbox label={"Show outlines"} bind:checked={showOutlines} />
    {/if}
  </div>
</div>

<style>
  .ui {
    width: 400px;
    border-right: 1px solid #aaaaaa;
    padding-bottom: 60px;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    overflow-x: visible;
    min-height: 100vh;
  }
  .ui-section {
    padding: 10px;
  }
  .ui-section-header {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
  }
  .ui-section-subheader {
    text-transform: uppercase;
    font-size: 12px;
  }
  .ui-section.grey {
    background-color: #f2f2f2;
  }
</style>
